import React from "react"; 
import { ResponsiveBar } from "@nivo/bar";

const BarChart = ({ data }) => {
  const totalRespuestas = data.reduce((sum, d) => sum + d.respuestas, 0);
  const colors = ["#003d80", "#003d80", "#003d80", "#F2A516", "#8A2BE2"];

  // Detectar el tamaño de la pantalla
  const isSmallScreen = window.innerWidth < 768; // Define un tamaño de pantalla pequeño

  return (
    <div style={{ height: isSmallScreen ? "300px" : "400px" }}> {/* Altura dinámica */}
      <ResponsiveBar
        data={data}
        keys={["respuestas"]}
        indexBy="area"
        margin={{
          top: isSmallScreen ? 10 : 20,
          right: isSmallScreen ? 20 : 30,
          bottom: isSmallScreen ? 60 : 80,
          left: isSmallScreen ? 40 : 60,
        }} // Márgenes dinámicos
        padding={isSmallScreen ? 0.2 : 0.25} // Ajusta el espaciado de las barras
        colors={({ index }) => colors[index % colors.length]}
        borderColor={{ from: "color", modifiers: [["darker", 1.6]] }}
        axisBottom={{
          tickSize: 5,
          tickPadding: 5,
          tickRotation: isSmallScreen ? -15 : -30, // Rotación de etiquetas
          legend: isSmallScreen ? "" : "Áreas de Interés", // Oculta la leyenda en pantallas pequeñas
          legendPosition: "middle",
          legendOffset: isSmallScreen ? 40 : 60,
        }}
        axisLeft={{
          tickSize: 5,
          tickPadding: 5,
          tickRotation: 0,
          legend: isSmallScreen ? "" : "Cantidad de Respuestas", // Oculta la leyenda en pantallas pequeñas
          legendPosition: "middle",
          legendOffset: isSmallScreen ? -40 : -50,
        }}
        labelSkipWidth={isSmallScreen ? 10 : 16} // Ajusta el tamaño para evitar solapamientos
        labelSkipHeight={isSmallScreen ? 10 : 16}
        labelTextColor="white"
        tooltip={({ id, value, color }) => {
          const percentage = ((value / totalRespuestas) * 100).toFixed(1);
          return (
            <div
              style={{
                padding: "5px 10px",
                color: "#fff",
                background: color,
                borderRadius: "4px",
                boxShadow: "0px 2px 5px rgba(0,0,0,0.15)",
              }}
            >
              <strong>{id}</strong>: {value}
              <br />
              ({percentage}% del total)
            </div>
          );
        }}
        animate={true}
        motionStiffness={85}
        motionDamping={15}
        theme={{
          axis: {
            ticks: {
              text: {
                fontSize: isSmallScreen ? 8 : 10, // Texto más pequeño en pantallas pequeñas
                fill: "#555",
              },
            },
            legend: {
              text: {
                fontSize: isSmallScreen ? 12 : 14, // Leyenda más pequeña
                fontWeight: "bold",
                fill: "#333",
              },
            },
          },
          labels: {
            text: {
              fontSize: isSmallScreen ? 8 : 10, // Etiquetas más pequeñas
              fontWeight: "bold",
              fill: "#333",
            },
          },
        }}
      />
    </div>
  );
};

export default BarChart;